(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-savings"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bundle-savings')){
  customElements.define('bundle-savings',class extends HTMLElement{
    connectedCallback(){
      this.formId=this.dataset.formId;
      this.scope=this.closest('.product-info')||document;
      this.form=document.getElementById(this.formId);
      this.variantPicker=this.scope.querySelector(`variant-picker[form-id="${CSS.escape(this.formId)}"]`);
      this.priceMap=JSON.parse(this.querySelector('[data-bundle-savings-map]').textContent);
      this.bundlePrice=Number(this.dataset.bundlePrice);
      window.__cokaciBundleState=window.__cokaciBundleState||{touched:new Set()};
      this.state=window.__cokaciBundleState;
      this.money=new Intl.NumberFormat(document.documentElement.lang||'tr-TR',{style:'currency',currency:this.dataset.currency,currencyDisplay:'narrowSymbol',maximumFractionDigits:2});
      this.percent=new Intl.NumberFormat(document.documentElement.lang||'tr-TR',{maximumFractionDigits:1});
      this.handleChange=this.handleChange.bind(this);
      this.handlePointerDown=this.handlePointerDown.bind(this);
      this.handleKeyDown=this.handleKeyDown.bind(this);
      this.handleSubmit=this.handleSubmit.bind(this);
      this.scope.addEventListener('pointerdown',this.handlePointerDown,true);
      this.scope.addEventListener('keydown',this.handleKeyDown,true);
      this.scope.addEventListener('change',this.handleChange);
      this.form?.addEventListener('submit',this.handleSubmit,true);
      this.update();
    }
    disconnectedCallback(){
      this.scope?.removeEventListener('pointerdown',this.handlePointerDown,true);
      this.scope?.removeEventListener('keydown',this.handleKeyDown,true);
      this.scope?.removeEventListener('change',this.handleChange);
      this.form?.removeEventListener('submit',this.handleSubmit,true);
    }
    interactionInput(target){
      if(target instanceof HTMLInputElement&&target.type==='radio')return target;
      const label=target?.closest?.(`variant-picker[handle="aci-tuz-pul-biber-kurutulmus-biber-seti"] label.block-swatch[for]`);
      if(!label)return null;
      return label.closest('variant-picker')?.querySelector(`#${CSS.escape(label.htmlFor)}`)||null;
    }
    positionFromInput(input){return input?.dataset?.optionPosition||input?.name?.match(/option(\d+)$/)?.[1]||null}
    markTouched(target){
      const input=this.interactionInput(target),position=this.positionFromInput(input);
      if(!position||!['1','2','3'].includes(position))return false;
      this.state.touched.add(position);
      return true;
    }
    handlePointerDown(event){
      if(!this.markTouched(event.target))return;
      window.setTimeout(()=>this.update(),0);
    }
    handleKeyDown(event){
      if(event.key!=='Enter'&&event.key!==' ')return;
      if(!this.markTouched(event.target))return;
      window.setTimeout(()=>this.update(),0);
    }
    handleChange(event){
      const input=event.target;
      if(!(input instanceof HTMLInputElement)||input.type!=='radio')return;
      const position=this.positionFromInput(input);
      if(position&&['1','2','3'].includes(position))this.state.touched.add(position);
      window.setTimeout(()=>this.update(),0);
    }
    handleSubmit(event){
      if(this.isComplete())return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    getSelected(position){
      const fieldName=`${this.formId}-option${position}`;
      return this.scope.querySelector(`input[type="radio"][name="${CSS.escape(fieldName)}"]:checked`)||this.scope.querySelector(`input[type="radio"][data-option-position="${position}"]:checked`);
    }
    isComplete(){return ['1','2','3'].every(position=>this.state.touched.has(position)&&this.getSelected(position))}
    maskUntouched(){
      for(const position of ['1','2','3']){
        const fieldName=`${this.formId}-option${position}`;
        const named=Array.from(this.scope.querySelectorAll(`input[type="radio"][name="${CSS.escape(fieldName)}"]`));
        const radios=named.length?named:Array.from(this.scope.querySelectorAll(`input[type="radio"][data-option-position="${position}"]`));
        radios.forEach(radio=>{const label=radio.id?this.scope.querySelector(`label[for="${CSS.escape(radio.id)}"]`):null;label?.classList.remove('bundle-placeholder-selected')});
        const checked=radios.find(radio=>radio.checked);
        const fieldset=radios[0]?.closest('.variant-picker__option');
        const checkedLabel=checked?.id?this.scope.querySelector(`label[for="${CSS.escape(checked.id)}"]`):null;
        if(this.state.touched.has(position)){
          if(fieldset&&checkedLabel){
            const selectedText=checkedLabel.textContent.trim();
            const selectedLabel=fieldset.querySelector('.variant-picker__option-info .h-stack > span');
            if(selectedLabel)selectedLabel.textContent=selectedText;
            const dropdownValue=fieldset.querySelector('[id$="-selected-value"]');
            if(dropdownValue)dropdownValue.textContent=selectedText;
          }
          continue;
        }
        if(checked?.id)this.scope.querySelector(`label[for="${CSS.escape(checked.id)}"]`)?.classList.add('bundle-placeholder-selected');
        if(fieldset){
          const selectedLabel=fieldset.querySelector('.variant-picker__option-info .h-stack > span');
          if(selectedLabel)selectedLabel.textContent='Seçiniz';
          const dropdownValue=fieldset.querySelector('[id$="-selected-value"]');
          if(dropdownValue)dropdownValue.textContent='Seçiniz';
        }
      }
    }
    currentVariant(){
      this.variantPicker=this.scope.querySelector(`variant-picker[form-id="${CSS.escape(this.formId)}"]`)||this.variantPicker;
      const script=this.variantPicker?.querySelector('script[data-variant]');
      try{return script?.textContent?.trim()?JSON.parse(script.textContent):null}catch(_){return null}
    }
    syncPurchaseState(){
      this.form=document.getElementById(this.formId)||this.form;
      if(!this.form)return;
      const complete=this.isComplete(),submitButton=this.form.querySelector('button[type="submit"]'),paymentButton=this.form.querySelector('.shopify-payment-button');
      if(!complete){
        if(submitButton){submitButton.disabled=true;submitButton.setAttribute('aria-disabled','true');submitButton.dataset.bundleSelectionLock='true'}
        if(paymentButton)paymentButton.style.display='none';
        return;
      }
      const variant=this.currentVariant();
      if(submitButton?.dataset.bundleSelectionLock==='true'){
        delete submitButton.dataset.bundleSelectionLock;
        if(variant?.available!==false){submitButton.disabled=false;submitButton.removeAttribute('aria-disabled')}
      }
      if(paymentButton&&variant?.available!==false)paymentButton.style.removeProperty('display');
    }
    syncHeaderPrice(regularPrice,saving){
      const priceBlock=this.scope.querySelector('.product-info__price');
      if(!priceBlock)return;
      const compare=priceBlock.querySelector('compare-at-price');
      const badge=priceBlock.querySelector('on-sale-badge');
      const regularCopy=new Intl.NumberFormat('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}).format(regularPrice/100)+'TL';
      const savingValue=saving/100;
      const savingNumber=Number.isInteger(savingValue)?String(savingValue):new Intl.NumberFormat('tr-TR',{maximumFractionDigits:2}).format(savingValue);
      const savingCopy=savingNumber+'TL indirim';
      if(compare){
        const sr=compare.querySelector('.sr-only');
        compare.replaceChildren();
        if(sr)compare.append(sr);
        compare.append(document.createTextNode(regularCopy));
      }
      if(badge){
        badge.textContent=savingCopy;
        badge.title=savingCopy;
      }
    }
    update(){
      this.maskUntouched();
      this.syncPurchaseState();
      if(!this.isComplete()){this.hidden=true;return}
      let regularPrice=0;
      for(const position of ['1','2','3']){
        const selected=this.getSelected(position),label=selected?.id?this.scope.querySelector(`label[for="${CSS.escape(selected.id)}"]`):null,value=label?.textContent.trim(),componentPrice=Number(this.priceMap[position]?.[value]);
        if(!value||!componentPrice){this.hidden=true;return}
        regularPrice+=componentPrice;
      }
      const saving=regularPrice-this.bundlePrice;
      if(saving<=0){this.hidden=true;return}
      this.syncHeaderPrice(regularPrice,saving);const savingMoney=this.money.format(saving/100),savingPercent=saving/regularPrice*100;
      this.querySelector('[data-bundle-regular-price]').textContent=this.money.format(regularPrice/100);
      this.querySelector('[data-bundle-saving-copy]').textContent=this.dataset.saveTemplate.replace('__SAVINGS__',savingMoney);
      this.querySelector('[data-bundle-saving-percent]').textContent=this.percent.format(savingPercent);
      this.hidden=false;
    }
  })
}
  } catch(e) { console.error(e); }
})();

})();
